import React, { memo } from 'react'

import { func } from 'prop-types'

import FreeBetaCard from '../FreeBetaCard/FreeBetaCard'
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard'

function EligibleForTrialBody({ onClose: handleClose }) {
  return (
    <div className="usage-modal__eligible-for-trial">
      <p className="usage-modal__headline cgt-body-md">
        You&apos;ve set everything up — now unlock generation to bring it to life.
      </p>

      <div className="usage-modal__cards">
        <FreeBetaCard onClose={handleClose} />
        <SubscriptionCard onClose={handleClose} />
      </div>
    </div>
  )
}

EligibleForTrialBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(EligibleForTrialBody)
